// Confidence formatting — the single place the SPA renders a 0–1 model
// confidence as a whole-percent string, so the review card, verdict card, and
// field rows agree. Callers append their own trailing word ("confident" /
// "confidence"). Mirrors the lib/dates.ts precedent of one shared formatter.

/** "87%" — a 0–1 confidence as a whole-percent string. */
export function formatConfidence(confidence: number): string {
  return `${Math.round(confidence * 100)}%`;
}
